import { Plan, Product, Sku } from "@brain/models";

export enum TransactionState {
    REQUESTED = "REQUESTED",
    DECLINED = "DECLINED",
    PROPOSED = "PROPOSED",
    ACCEPTED = "ACCEPTED",
    ERROR = "ERROR"
}

export interface Transaction {

    asset_owner: string;

    business_info: {
        buyer_legal_entity_type: string;

        buyer_legal_name: string;

        client_name: string;

        engagement_name: string;

        prime_ppd_email: string;

        prime_ppd_name: string;

        wbs_engagement_other_code: string;
    };

    buyer_email: string;

    buyer_name: string;

    country_iso: string;

    date: string;

    invitatio_open: false;

    plan_id: string;

    product_id: string;

    product_name: string;

    sku_id: string;

    state: string;

    sub_id: string;

    subscription_id: string;

    tos: {
        text: string;
    };

    tou: {
        text: string;
    };

    invitatio: {
        text: string;
    };

    tos_present: boolean;

    plan: Plan;

    transaction_id: string;
}

export interface TransactionResponse {
    detail: "success" | "error";
    transaction: Transaction;
}

export interface TransactionCreateResponse {
    detail: string;
    tos_present: boolean;
    transaction_id: string;
}

export interface TransactionData {
    transaction: Transaction;
    plan: Plan;
    product: Product;
    sku: Sku;
}
